import View from 'mixins/view';

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(`
            <figure class="c-comments__avatar">
                <img src="${ model.get('thumbnail') }" alt="User Photo">
            </figure>
        `));
    }
    buildTooltip() {
        const role = this.getModel().get('type');
        const roleLabel = {
            'author': `
                <span class="c-comments__role c-comments__role--author">
                    <strong class="js-tooltipBox-Call" data-ui-tooltip-content="Autor" data-ui-tooltip-color="#ff0000" ui-tooltip-topposition="100%" ui-tooltip-leftposition="0">A</strong>
                </span>
            `,
            'editor': `
                <span class="c-comments__role c-comments__role--editor">
                    <strong class="js-tooltipBox-Call" data-ui-tooltip-content="Redaktor" data-ui-tooltip-color="#1f1e7b" ui-tooltip-topposition="100%" ui-tooltip-leftposition="0">R</strong>
                </span>
            `,
            'moderator': `
                <span class="c-comments__role c-comments__role--moderator">
                    <strong class="js-tooltipBox-Call" data-ui-tooltip-content="Moderator" data-ui-tooltip-color="#f49a0b">M</strong>
                </span>
            `,
        };

        if (roleLabel[role]) {
            this.rootEl.append(roleLabel[role]);
        }
    }
    render() {
        this.buildTooltip();
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/avatar-view.js